"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
  var clientWidth = el.clientWidth;
  var _getComputedStyle = getComputedStyle(el),
    paddingLeft = _getComputedStyle.paddingLeft,
    paddingRight = _getComputedStyle.paddingRight;
  return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}